import { type JSX } from "react";
import { TruncatedText } from "@via/components/truncated-text.tsx";
import { classNames } from "@via/utils/helpers.tsx";

export const Badge = ({
  text,
  textColor,
  fillColor,
  id,
  maxLength = 15,
}: {
  text: string;
  textColor: string;
  fillColor: string;
  id?: string;
  maxLength?: number;
}): JSX.Element => {
  return (
    <span
      className={classNames(
        textColor,
        "inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ring-gray-200 truncate"
      )}>
      <svg
        className={classNames(fillColor, "h-1.5 w-1.5")}
        viewBox="0 0 6 6"
        aria-hidden="true">
        <circle cx={3} cy={3} r={3} />
      </svg>
      <TruncatedText
        {...(id ? { id } : { id: `badge-${textColor}-${text}` })}
        text={text}
        maxLength={maxLength}
      />
    </span>
  );
};
